<div class="home-skeleton" [class.kpis-only]="variant === 'kpis'" role="status" aria-live="polite" aria-busy="true">
    <span class="sr-only">{{variant === 'kpis' ? 'Loading performance summary' : 'Loading your dashboard'}}</span>
    <div aria-hidden="true">
        <div class="skeleton-header" *ngIf="variant !== 'kpis'">
            <div class="skeleton-greeting"><span class="bone eyebrow"></span><span class="bone title"></span><span class="bone subtitle"></span></div>
            <div class="skeleton-buttons"><span class="bone button"></span><span class="bone button"></span></div>
        </div>
        <div class="skeleton-kpis" *ngIf="variant !== 'applicant'">
            <div class="skeleton-panel kpi" *ngFor="let tile of tiles"><span class="bone label"></span><span class="bone value"></span><span class="bone caption"></span></div>
        </div>
        <div class="skeleton-layout" *ngIf="variant !== 'kpis'">
            <div class="skeleton-column">
                <div class="skeleton-panel">
                    <div class="panel-heading"><span class="bone heading"></span><span class="bone chip"></span></div>
                    <ng-container *ngIf="variant === 'schedule'; else applicantCard">
                        <div class="schedule-row" *ngFor="let row of rows"><span class="bone time"></span><div class="row-copy"><span class="bone name"></span><span class="bone description"></span></div><span class="bone chip"></span></div>
                    </ng-container>
                    <ng-template #applicantCard>
                        <div class="applicant-card"><span class="bone title"></span><span class="bone subtitle"></span>
                            <div class="detail-grid"><div *ngFor="let tile of tiles"><span class="bone label"></span><span class="bone name"></span></div></div>
                            <span class="bone button"></span>
                        </div>
                    </ng-template>
                </div>
                <div class="skeleton-panel">
                    <div class="panel-heading"><span class="bone heading"></span></div>
                    <div class="history-row" *ngFor="let row of rows"><span class="bone time"></span><span class="bone description"></span><span class="bone chip"></span></div>
                </div>
            </div>
            <div class="skeleton-panel task-panel">
                <div class="panel-heading"><span class="bone heading"></span><span class="bone count"></span></div>
                <div class="task-row" *ngFor="let task of tasks"><span class="bone icon"></span><div class="row-copy"><span class="bone name"></span><span class="bone description"></span></div></div>
            </div>
        </div>
    </div>
</div>
